import classNames from 'classnames';
import React, { useState, useEffect } from 'react';
import { CSSTransition } from 'react-transition-group';

const Alert = ({ type, asText, children, shown, className, hideIcon, duration, afterHideHandler }) => {
  if (type === 'error') type = 'danger';

  const [isShown, setIsShown] = useState(shown);
  const [animateClasses, setAnimateClasses] = useState('fadeInDown');

  const delay = (ms) => {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(2);
      }, ms);
    });
  };

  useEffect(() => {
    const timer = setTimeout(async () => {
      if (duration && isShown) {
        setAnimateClasses('fadeOutUp');
        await delay(200);
        setIsShown(false);

        afterHideHandler && afterHideHandler();
      }
    }, duration);

    return () => {
      if (timer) {
        clearTimeout(timer);
      }
    };
  }, [duration, isShown]);

  return isShown || (asText && shown) ? (
    <div
      className={classNames(`plum-alert ${type} ${animateClasses}`, className, {
        'as-text': asText,
      })}>
      {type === 'danger' && (
        <i className='fa fa-exclamation-triangle me-2' hidden={hideIcon || !shown} aria-hidden='true'></i>
      )}
      {children}
    </div>
  ) : null;
};

Alert.defaultProps = {
  hideIcon: false,
  asText: false,
  shown: false,
};

export default Alert;
